/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Hyphen_Space_LabelInputs */

const en_style_guide_manager_hyphen_space_label = /** @type {(inputs: Style_Guide_Manager_Hyphen_Space_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyphen With Space`)
};

const fr_style_guide_manager_hyphen_space_label = /** @type {(inputs: Style_Guide_Manager_Hyphen_Space_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiret avec espace`)
};

const de_style_guide_manager_hyphen_space_label = /** @type {(inputs: Style_Guide_Manager_Hyphen_Space_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bindestrich mit Leerzeichen`)
};

const it_style_guide_manager_hyphen_space_label = /** @type {(inputs: Style_Guide_Manager_Hyphen_Space_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trattino con spazio`)
};

const ru_style_guide_manager_hyphen_space_label = /** @type {(inputs: Style_Guide_Manager_Hyphen_Space_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дефис с пробелом`)
};

const es_style_guide_manager_hyphen_space_label = /** @type {(inputs: Style_Guide_Manager_Hyphen_Space_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guión con espacio`)
};

const zh_cn2_style_guide_manager_hyphen_space_label = /** @type {(inputs: Style_Guide_Manager_Hyphen_Space_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带空格的连字符`)
};

const ja_style_guide_manager_hyphen_space_label = /** @type {(inputs: Style_Guide_Manager_Hyphen_Space_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペース付きハイフン`)
};

const hi_style_guide_manager_hyphen_space_label = /** @type {(inputs: Style_Guide_Manager_Hyphen_Space_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाइफ़न के साथ स्पेस`)
};

const pt_pt2_style_guide_manager_hyphen_space_label = /** @type {(inputs: Style_Guide_Manager_Hyphen_Space_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hífen com espaço`)
};

/**
* | output |
* | --- |
* | "Hyphen With Space" |
*
* @param {Style_Guide_Manager_Hyphen_Space_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_hyphen_space_label = /** @type {((inputs?: Style_Guide_Manager_Hyphen_Space_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Hyphen_Space_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_hyphen_space_label(inputs)
	if (locale === "de") return de_style_guide_manager_hyphen_space_label(inputs)
	if (locale === "it") return it_style_guide_manager_hyphen_space_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_hyphen_space_label(inputs)
	if (locale === "es") return es_style_guide_manager_hyphen_space_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_hyphen_space_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_hyphen_space_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_hyphen_space_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_hyphen_space_label(inputs)
	return en_style_guide_manager_hyphen_space_label(inputs)
});